import { flatten, uniq } from "lodash/array";
import { filter, map } from "lodash/collection";
import { maxBy } from "lodash/math";
import { cloneDeep } from "lodash/lang";
import { range } from "lodash/util";

export default {
  filter,
  map,
  maxBy,
  flatten,
  uniq,
  cloneDeep,
  range
};
